import styled from "styled-components";

export const AppItemContainer = styled("a")`
  display: block;
  text-decoration: none;
`;
